<div class="col-xs-4 col-md-4 col-centered col-slider no-padding row">
  <div class="small text-center" *ngIf="!schema.isLoaded">загрузка...</div>
  <payment-distribution-schema-form *ngIf="schema.isLoaded" [freighter]="freighter" [schema]="schema" (back)="onBack()"
                         (saved)="onSaved()"></payment-distribution-schema-form>
</div>
